/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 26.10.17.
 */

import React from "react";
import {t} from "../../../trans";

/**
 * Overrided ErrorList template. Shows only global object errors. Field errors will be displayed next to the corresponding field.
 * @param props
 * @return {XML}
 * @constructor
 */
export default function ErrorListTemplate(props) {
    const {errors, errorSchema} = props;
    if (!errorSchema.__errors || errorSchema.__errors.length == 0) return (<div/>);

    return (
        <div className="panel panel-danger errors">
            <div className="panel-heading">
                <h3 className="panel-title">{t("Errors")}</h3>
            </div>
            <ul className="list-group">
                {errorSchema.__errors.map((error, i) => {
                    return (
                        <li key={i} className="list-group-item text-danger">
                            {error}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
